import Endpoints from "../enums/Endpoints";
import { GetWithoutId } from "./base/Connection";

const Get = () => {
    return GetWithoutId(Endpoints.Dashboard);
}

export { Get }